// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const FileCsvIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path d="M10.294 15.016C10.248 14.024 9.571 14 8.651 14C7.235 14 7 14.338 7 15.667V17.333C7 18.662 7.235 19 8.651 19C9.571 19 10.249 18.976 10.294 17.984M21 14L19.537 17.912C19.265 18.637 19.13 19 18.915 19C18.7 19 18.565 18.637 18.293 17.912L16.83 14M14.721 14H13.749C13.36 14 13.166 14 13.013 14.063C12.491 14.279 12.498 14.787 12.498 15.25C12.498 15.713 12.491 16.22 13.013 16.437C13.166 16.5 13.36 16.5 13.749 16.5C14.137 16.5 14.332 16.5 14.485 16.563C15.007 16.779 15 17.287 15 17.75C15 18.213 15.007 18.72 14.485 18.937C14.332 19 14.137 19 13.749 19H12.689" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" />
        <path d="M19 11C19 10 19 9.43 18.848 9.063C18.696 8.696 18.407 8.406 17.828 7.828L13.092 3.092C12.593 2.593 12.344 2.344 12.034 2.196C11.9698 2.16518 11.9041 2.13781 11.837 2.114C11.514 2 11.161 2 10.456 2C7.211 2 5.588 2 4.489 2.886C4.26709 3.06494 4.06494 3.26709 3.886 3.489C3 4.59 3 6.211 3 9.456V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H19M12 2.5V3C12 5.828 12 7.243 12.879 8.121C13.757 9 15.172 9 18 9H18.5" stroke={color || '#141414'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { FileCsvIcon };
